<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Pre-registro de Verano</h3>
                        </div>
                    </v-card-title>
                    <!-- Fuera de tiempo -->
                    <v-card-text v-if="fueraDeTiempo">
                        <v-alert type="info" :value="true">
                            El período de registro para el curso de verano no está disponible en este momento.
                        </v-alert>
                    </v-card-text>

                    <!-- Ya guardado -->
                    <v-card-text v-else-if="yaGuardado">
                        <v-alert type="warning" :value="true" class="mb-3">
                            <p class="mb-1">Seleccionar materias en esta sección no garantiza que el grupo se abra, ni que puedas cursar la materia en verano. El proceso de selección es únicamente para que el coordinador de carrera tenga una idea de la demanda de cada materia y así tomar decisiones sobre la apertura de grupos.</p>
                            <p class="mb-0">No realizar el pago o transferencia del curso de verano, hasta que tu coordinador de carrera te notifique la apertura oficial del mismo, de lo contrario cualquier pago realizado sin la autorización debida, NO habrá devolución ni compensación del pago correspondiente.</p>
                        </v-alert>
                        <v-alert type="success" :value="true" class="mb-3">
                            Tu selección de materias para verano ha sido registrada. No es posible realizar cambios.
                        </v-alert>
                        <p class="subheading">Materias registradas:</p>
                        <v-list two-line>
                            <v-list-tile v-for="item in materiasGuardadas" :key="item.materia">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.nombre }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.materia }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card-text>

                    <!-- Registro abierto -->
                    <v-card-text v-else-if="!cargandoDatos && materias.length > 0">
                        <v-alert type="warning" :value="true" class="mb-3">
                            <p class="mb-1">Seleccionar materias en esta sección no garantiza que el grupo se abra, ni que puedas cursar la materia en verano. El proceso de selección es únicamente para que el coordinador de carrera tenga una idea de la demanda de cada materia y así tomar decisiones sobre la apertura de grupos.</p>
                            <p class="mb-0">No realizar el pago o transferencia del curso de verano, hasta que tu coordinador de carrera te notifique la apertura oficial del mismo, de lo contrario cualquier pago realizado sin la autorización debida, NO habrá devolución ni compensación del pago correspondiente.</p>
                        </v-alert>

                        <v-alert
                            v-if="mensaje"
                            :type="mensajeTipo"
                            dismissible
                            @input="mensaje = ''"
                            class="mb-3"
                        >
                            {{ mensaje }}
                        </v-alert>

                        <div class="mb-3">
                            <v-btn
                                color="primary"
                                :disabled="seleccionadas.length < 1"
                                :loading="guardando"
                                @click="guardar"
                            >
                                Guardar selección
                            </v-btn>
                            <span class="ml-2 grey--text caption">
                                Selecciona entre 1 y 2 materias
                                ({{ seleccionadas.length }}/2 seleccionadas)
                            </span>
                        </div>

                        <v-data-table
                            :headers="headers"
                            :items="materias"
                            hide-actions
                            v-if="$mq !== 'sm'"
                        >
                            <template slot="items" slot-scope="props">
                                <td>
                                    <v-checkbox
                                        :input-value="seleccionadas.includes(props.item.materia)"
                                        :disabled="seleccionadas.length >= 2 && !seleccionadas.includes(props.item.materia)"
                                        @change="toggleMateria(props.item.materia)"
                                        hide-details
                                        class="mt-0 pt-0"
                                    ></v-checkbox>
                                </td>
                                <td>
                                    <div>{{ props.item.nombre }}</div>
                                    <div class="caption grey--text">{{ props.item.materia }}</div>
                                </td>
                                <td>{{ props.item.semestre }}</td>
                                <td>{{ props.item.creditos }}</td>
                                <td>{{ props.item.horasTeoricas }}</td>
                                <td>{{ props.item.horasPracticas }}</td>
                                <td>
                                    <v-chip
                                        small
                                        :color="estatusColor(props.item.estatus)"
                                        text-color="white"
                                    >{{ props.item.estatus }}</v-chip>
                                </td>
                            </template>
                        </v-data-table>

                        <v-data-iterator
                            :items="materias"
                            :rows-per-page-items="[10]"
                            content-tag="v-layout"
                            row
                            wrap
                            v-else-if="$mq === 'sm'"
                        >
                            <v-flex
                                slot="item"
                                slot-scope="props"
                                xs12
                                sm6
                                md4
                                lg3
                            >
                                <v-card>
                                    <v-card-title primary-title>
                                        <v-checkbox
                                            :input-value="seleccionadas.includes(props.item.materia)"
                                            :disabled="seleccionadas.length >= 2 && !seleccionadas.includes(props.item.materia)"
                                            @change="toggleMateria(props.item.materia)"
                                            hide-details
                                            class="mt-0 pt-0"
                                        ></v-checkbox>
                                        <div>
                                            <h4>{{ props.item.nombre }}</h4>
                                            <div class="caption grey--text">{{ props.item.materia }}</div>
                                        </div>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content>Semestre:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.semestre }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Créditos:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.creditos }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Hrs. Teóricas:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.horasTeoricas }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Hrs. Prácticas:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.horasPracticas }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Estatus:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">
                                                <v-chip
                                                    small
                                                    :color="estatusColor(props.item.estatus)"
                                                    text-color="white"
                                                >{{ props.item.estatus }}</v-chip>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-data-iterator>
                    </v-card-text>

                    <v-card-text v-else-if="!cargandoDatos">
                        Has acreditado todas las materias de tu plan de estudios.
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando materias</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'VeranoPage',
    mounted () {
      this.getMateriasPendientes()
    },
    data: () => ({
      cargandoDatos: true,
      guardando: false,
      fueraDeTiempo: false,
      yaGuardado: false,
      materiasGuardadas: [],
      headers: [
        { text: '', value: 'checkbox', sortable: false },
        { text: 'Materia', align: 'left', value: 'nombre' },
        { text: 'Semestre', value: 'semestre' },
        { text: 'Créditos', value: 'creditos' },
        { text: 'Hrs. Teóricas', value: 'horasTeoricas' },
        { text: 'Hrs. Prácticas', value: 'horasPracticas' },
        { text: 'Estatus', value: 'estatus', sortable: false }
      ],
      materias: [],
      seleccionadas: [],
      mensaje: '',
      mensajeTipo: 'success'
    }),
    methods: {
      getMateriasPendientes () {
        axios.get('alumno/verano')
          .then(response => {
            this.fueraDeTiempo = response.data.fueraDeTiempo
            this.yaGuardado = response.data.yaGuardado
            this.materias = response.data.data
            this.materiasGuardadas = response.data.materiasGuardadas || []
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      },
      toggleMateria (materia) {
        const idx = this.seleccionadas.indexOf(materia)
        if (idx >= 0) {
          this.seleccionadas.splice(idx, 1)
        } else if (this.seleccionadas.length < 2) {
          this.seleccionadas.push(materia)
        }
      },
      estatusColor (estatus) {
        if (estatus === 'Curso normal') return 'green'
        if (estatus === 'Repetición') return 'orange'
        return 'red'
      },
      guardar () {
        if (this.seleccionadas.length < 1) return
        this.guardando = true
        this.mensaje = ''
        axios.post('alumno/verano', { materias: this.seleccionadas.slice(0, 2) })
          .then(response => {
            this.mensajeTipo = 'success'
            this.mensaje = response.data.message
            this.yaGuardado = true
            this.materiasGuardadas = this.seleccionadas.map(code => {
              const found = this.materias.find(m => m.materia === code)
              return { materia: code, nombre: found ? found.nombre : code }
            })
          })
          .catch(() => {
            this.mensajeTipo = 'error'
            this.mensaje = 'Ocurrió un error al guardar. Inténtalo de nuevo.'
          })
          .finally(() => {
            this.guardando = false
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/inscripciones/VeranoPage.vue